import "@/App.css";
import { lazy, Suspense, useState } from "react";
import { AppProviders, useScrollCtx, useMouseCtx } from "@/providers/AppProviders";
import { Overlays } from "@/components/overlays/Overlays";

const Experience = lazy(() =>
  import("@/components/experience/Experience").then((m) => ({ default: m.Experience })),
);
import { Navbar } from "@/components/ui-custom/Navbar";
import { FrameIndicator } from "@/components/ui-custom/FrameIndicator";
import { ScrollProgressBar } from "@/components/ui-custom/ScrollProgressBar";
import { CustomCursor } from "@/components/ui-custom/CustomCursor";
import { Loader } from "@/components/ui-custom/Loader";
import { Toaster } from "@/components/ui/sonner";

const SCROLL_VH = 720;

const Stage = () => {
  const { progress } = useScrollCtx();
  const mouse = useMouseCtx();
  const [ready, setReady] = useState(false);

  return (
    <>
      <Loader ready={ready} />
      <CustomCursor />

      {/* Layer 1 — background */}
      <div className="fixed inset-0 z-0 bg-stage" aria-hidden="true" />
      {/* Layer 2 — WebGL scene */}
      <div className="fixed inset-0 z-[1]">
        <Suspense fallback={null}>
          <Experience
            progress={progress}
            mouse={mouse}
            onReady={() => setReady(true)}
          />
        </Suspense>
      </div>
      {/* grain */}
      <div className="grain-overlay" aria-hidden="true" />

      {/* Layer 6 — HUD / overlays */}
      <Overlays />
      <ScrollProgressBar />
      <Navbar />
      <FrameIndicator />

      {/* scroll track */}
      <div style={{ height: `${SCROLL_VH}vh` }} aria-hidden="true" />

      <Toaster position="bottom-center" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AppProviders>
        <Stage />
      </AppProviders>
    </div>
  );
}

export default App;
